import PrimaryButton from "../Forms/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useApiCall } from "../../services/api";
import { Modal, Typography } from "antd";
const { Title } = Typography;

const ChatBox = ({ isOpen, closeModal, allData }) => {
  if (!isOpen) return null;
  return (
    <>
      <Modal
        className="form-css custom-modal my-5"
        open={isOpen}
        footer={null}
        onCancel={closeModal}
        centered
        width={400}
      >
        <Title level={2} className="font-abhaya mb-3 !font-[400]">
          {"Support"}
        </Title>
        <div className="flex gap-2 items-center">
          <div className="rounded-xl bg-[#F4F4F4]">
            <img className="h-[50px] w-[50px]" src="/assets/icons/welcome-logo.png"></img>
          </div>
          <div className="text-[#000] text-xl font-bold">Hello!</div>
        </div>
        <div>
          <div className="text-[#000] text-left mt-4">
            <p>We’re here to assist you every step of the way.</p>
            <p className="mt-4">
              Your assigned sales representative is{" "}
              <span className="font-bold">{allData?.full_name}. </span>
              For any queries or support, you can reach them on:{" "}
              <span className="font-bold">
                {allData?.display_contact_no} or {allData?.email}{". "}
              </span>
            </p>
            <p className="mt-4">We're happy to help!</p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ChatBox;
